export const SHOW_FEATURE_FLAG_CONSOLE = 'showFeatureFlagConsole';
export const SHOPPING_LIST = 'shoppingList';
export const WHISK_SHOPPING_CART = 'whiskShoppingCart';
export const BASKET_ADDRESS_ALERT = 'basketAddressAlert';
export const PANTRY_V1 = 'pantryV1';
export const PANTRY_V2 = 'pantryV2';
